import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { timer } from 'rxjs';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss', './carousel.component.media.scss']
})
export class CarouselComponent implements OnInit, OnDestroy {
  @Input() set list(list) {
    this.carouselList = list.map((v, i) => {
      return {
        active: i === 0,
        background: v,
      };
    });
  }
  carouselList = [];
  current = 0;
  timeout$ = timer(7000, 8000);
  sub = null;
  constructor() {
    console.log('init');
  }

  ngOnInit() {
    this._subscribeTimer();
  }
  ngOnDestroy() {
    console.log('destroy');
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
  _subscribeTimer() {
    console.log('begin');
    this.sub = this.timeout$.subscribe(
      v => {
        console.log(v);
        const next = (this.current + 1) % (this.carouselList.length);
        this.carouselList[this.current].active = false;
        this.carouselList[next].active = true;
        this.current = next;
      },
      err => console.log('err', err),
      () => {
        console.log('complete');
      }
    );
  }
  handleChooseCircle(i) {
      if (i === this.current) {
          return true;
      }
      this.sub.unsubscribe();
      this.carouselList[this.current].active = false;
      this.carouselList[i].active = true;
      this.current = i;
      this._subscribeTimer();
  }
}
